@if (value) {
  <div class="date-format" [matTooltip]="value">{{ value }}</div>
} @else {
  <span [matTooltip]="notAvailable">{{ notAvailable }}</span>
}
